/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    methods: {
        getFields() {
            return (this.$children || [])
                .filter(vnode => vnode && vnode._isFields);
        },

        validateFields(callback = null) {
            const fields = this.getFields();
            const validates = [this.$validator.validate()];

            fields.forEach(field => {
                validates.push(field.$validator.validate());
            });

            Promise.all(validates).then(values => {
                if (values.includes(false)) return;

                if (callback) {
                    callback();
                } else if (this.validateSuccess) {
                    this.validateSuccess();
                } else {
                    throw new Error('formFieldsMixin: Add a calllback to validateFields() or set validateSuccess method');
                }
            });
        },
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class FormFieldsMixin extends Vue {}